<template>
  <div>
    <v-divider></v-divider>
    <v-list nav dense>
      <v-subheader v-if="!hideSeeAlso">See Also</v-subheader>
      <v-list-item
        v-for="(obj, key) in itemsToShow"
        :key="key"
        :disabled="obj.pro && !isSubscribed"
        :to="obj.to"
      >
        <v-list-item-icon small
          ><v-icon color="primary"
            >mdi-{{ obj.icon ? obj.icon : "clipboard-text-outline" }}</v-icon
          >
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> {{ obj.name }}</v-list-item-title>
          <v-list-item-subtitle
            v-if="obj.pro && !isSubscribed"
            class="red--text"
            >PRO Feature</v-list-item-subtitle
          ></v-list-item-content
        ></v-list-item
      >
    </v-list>
  </div>
</template>

<script>
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "CodingSeeAlso",
  props: { currentKey: null, hideSeeAlso: null },
  mixins: [UserMixin], // for isSubscribed
  data: function () {
    return {
      items: {
        icd10: {
          name: "ICD10 Codes",
          pro: false,
          to: "/icd10",
          icon: null,
        },
        "diabetes-widget": {
          name: "Diabetes Widget",
          pro: false,
          to: "/icd10/diabetic-retinopathy-widget",
          icon: null,
        },
        "billing-codes": {
          name: "Billing Codes",
          pro: true,
          to: "/billing-codes",
          icon: null,
        },
        "billing-protocols": {
          name: "Billing Protocols",
          pro: false,
          to: "/billing-protocols",
          icon: "repeat",
        },

        "coding-clinical-examples": {
          name: "Coding Clinical Examples",
          pro: true,
          to: "/coding-clinical-examples",
          icon: "repeat",
        },
        "coding-widget": {
          name: "Coding Widget",
          pro: true,
          to: "/coding-widget",
          icon: "widgets-outline",
        },
      },
    };
  },
  methods: {},
  computed: {
    itemsToShow: function () {
      let rtn = {};
      for (let key in this.items) {
        if (key != this.currentKey) rtn[key] = this.items[key];
      }
      return rtn;
    },
  },
};
</script>

<style scoped></style>
